import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LiveClassAdd.css";

const LiveClassAdd = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [teacherName, setteacherName] = useState([]);
  const [price, setPrice] = useState("");
  const [thumbnail, setThumbnail] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("price", price);
    formData.append("thumbnail", thumbnail);

    // Append multiple teacher names
    teacherName.forEach((teacher, index) => {
      formData.append(`teacherName[${index}]`, teacher);
    });

    try {
      await axios.post(`${API_BASE_URL}/admin/live-classes`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      alert("Live class added successfully!");
      navigate("/live-class-list");
    } catch (error) {
      console.error("Failed to add live class:", error);
    }
  };

  const handleAddTeacherName = () => {
    setteacherName([...teacherName, ""]);
  };

  const handleTeacherNameChange = (index, value) => {
    const updatedteacherName = [...teacherName];
    updatedteacherName[index] = value;
    setteacherName(updatedteacherName);
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Live Classes</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={() => navigate("/live-class-add")}
            >
              + Add New Live Class
            </button>
            <button
              className="allSubjects"
              onClick={() => navigate("/live-class-list")}
            >
              All Live Class
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Live Class Details</h4>
          <form className="subject-detail-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="label">Title</label>
              <input
                type="text"
                placeholder="Enter Title"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="label">Description</label>
              <input
                type="text"
                placeholder="Enter Description"
                required
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="label">Teacher names</label>
              {teacherName.map((teacher, index) => (
                <input
                  key={index}
                  type="text"
                  placeholder="Enter Subject Teacher names"
                  required
                  className="mt-2"
                  value={teacher}
                  onChange={(e) =>
                    handleTeacherNameChange(index, e.target.value)
                  }
                />
              ))}
              <button
                type="button"
                className="btn-add-teacher"
                onClick={handleAddTeacherName}
              >
                + Add Teacher
              </button>
            </div>

            <div className="input-group">
              <label className="label">Price</label>
              <input
                type="text"
                placeholder="Enter Price"
                required
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="label">Thumbnail</label>
              <input
                type="file"
                onChange={(e) => setThumbnail(e.target.files[0])}
              />
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/live-class-list")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LiveClassAdd;
